import { ELASTIC_SEARCH_SORT_ORDER } from '@models/elastic-search/request/elastic-search-sort-order.enum';

export class ElasticSearchSortValue {
  field: string;
  order: ELASTIC_SEARCH_SORT_ORDER;
  notKeyword: boolean;

  constructor(field: string = '', order: ELASTIC_SEARCH_SORT_ORDER = ELASTIC_SEARCH_SORT_ORDER.NONE, notKeyword: boolean = false) {
    this.field = field;
    this.order = order;
    this.notKeyword = notKeyword;
  }
}